module.exports = __webpack_public_path__ + "img/parking-lot-5.801dd4cd.jpg";